(function () {
  'use strict';

  var SECTION_SEL = '.blog-post';
  var CONTENT_SEL = '.blog-post__content';
  var PROGRESS_SEL = '.blog-post__progress';
  var TOC_NAV_SEL = '.blog-post__toc-nav';
  var MOBILE_NAV_SEL = '.blog-post__mobile-nav';
  var MOBILE_NAV_LINKS_SEL = '.blog-post__mobile-nav-inner';
  var MOBILE_SCROLL_THRESHOLD = 300;

  function init() {
    var section = document.querySelector(SECTION_SEL);
    if (!section) return;

    var progressBar = section.querySelector(PROGRESS_SEL);
    var tocNav = section.querySelector(TOC_NAV_SEL);
    var mobileNav = section.querySelector(MOBILE_NAV_SEL);
    var mobileNavLinks = mobileNav ? mobileNav.querySelector(MOBILE_NAV_LINKS_SEL) : null;
    var content = section.querySelector(CONTENT_SEL);
    if (!content) return;

    // Collect H2s from article content
    var headings = content.querySelectorAll('h2');
    if (headings.length === 0) return;

    // Ensure each H2 has an id for anchor links
    headings.forEach(function (h, i) {
      if (!h.id) {
        h.id = 'section-' + (i + 1);
      }
    });

    // Build TOC links
    if (tocNav) {
      buildTOC(tocNav, headings);
    }

    // Build mobile nav links
    if (mobileNavLinks) {
      buildMobileNav(mobileNavLinks, headings);
    }

    // Progress bar
    if (progressBar) {
      setupProgressBar(progressBar);
    }

    // Scroll-spy via IntersectionObserver
    setupScrollSpy(headings, tocNav, mobileNav);

    // Mobile nav show/hide
    if (mobileNav) {
      setupMobileNavVisibility(mobileNav);
    }
  }

  function buildTOC(container, headings) {
    headings.forEach(function (h, i) {
      var link = document.createElement('a');
      link.href = '#' + h.id;
      link.className = 'blog-post__toc-link';
      link.setAttribute('data-toc-index', i);

      var num = String(i + 1).padStart(2, '0');
      link.textContent = num + '. ' + truncateText(h.textContent, 50);

      link.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth' });
      });

      container.appendChild(link);
    });
  }

  function buildMobileNav(container, headings) {
    // Clear existing placeholder content
    container.innerHTML = '';

    var icons = ['ph ph-eye', 'ph ph-shield', 'ph ph-sparkle', 'ph ph-chat-dots', 'ph ph-list'];

    headings.forEach(function (h, i) {
      if (i > 0) {
        var divider = document.createElement('div');
        divider.className = 'blog-post__mobile-nav-divider';
        container.appendChild(divider);
      }

      var link = document.createElement('a');
      link.href = '#' + h.id;
      link.className = 'blog-post__mobile-nav-link';
      link.setAttribute('data-toc-index', i);

      var icon = document.createElement('i');
      icon.className = icons[i % icons.length];
      link.appendChild(icon);

      var span = document.createElement('span');
      span.textContent = truncateText(h.textContent, 12);
      link.appendChild(span);

      link.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth' });
      });

      container.appendChild(link);
    });
  }

  function setupProgressBar(bar) {
    window.addEventListener('scroll', function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (docHeight <= 0) return;
      var pct = Math.min((scrollTop / docHeight) * 100, 100);
      bar.style.width = pct + '%';
    }, { passive: true });
  }

  function setupScrollSpy(headings, tocNav, mobileNav) {
    var allLinks = [];
    if (tocNav) {
      allLinks = allLinks.concat(Array.from(tocNav.querySelectorAll('.blog-post__toc-link')));
    }
    if (mobileNav) {
      allLinks = allLinks.concat(Array.from(mobileNav.querySelectorAll('.blog-post__mobile-nav-link')));
    }
    if (allLinks.length === 0) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var activeId = entry.target.id;
          // Find the index matching this heading
          var idx = -1;
          headings.forEach(function (h, i) {
            if (h.id === activeId) idx = i;
          });
          if (idx === -1) return;

          allLinks.forEach(function (link) {
            var linkIdx = parseInt(link.getAttribute('data-toc-index'), 10);
            if (linkIdx === idx) {
              link.classList.add('is-active');
            } else {
              link.classList.remove('is-active');
            }
          });
        }
      });
    }, {
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0
    });

    headings.forEach(function (h) {
      observer.observe(h);
    });
  }

  function setupMobileNavVisibility(nav) {
    window.addEventListener('scroll', function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > MOBILE_SCROLL_THRESHOLD) {
        nav.classList.add('is-visible');
      } else {
        nav.classList.remove('is-visible');
      }
    }, { passive: true });
  }

  function truncateText(text, maxLen) {
    text = text.trim();
    if (text.length <= maxLen) return text;
    return text.substring(0, maxLen).trim() + '…';
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
